import { render, staticRenderFns } from "./tooltip.vue?vue&type=template&id=23ec257e"
import script from "./tooltip.vue?vue&type=script&lang=ts"
export * from "./tooltip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports